import { useEffect, useState } from 'react';
import { Typography, notification } from 'antd';

import { axiosGet, axiosPost } from '../../services/http.services';
import {
  API_AIRLINES,
  API_DELETE_AIRLINE,
  API_UPDATE_AIRLINE,
} from '../../api/api';
import EditableGridTable from '../../customs/EditableGridTable';


const { Title } = Typography;


const normalizeExcelHeader = (value) => String(value || '').replace(/\\n/g, '\n');


const AirlineManagementSection = ({ canEdit = false }) => {
  const [rows, setRows] = useState([]);

  const loadRows = async () => {
    try {
      const response = await axiosGet(`${API_AIRLINES}?include_inactive=true`);
      setRows(response?.data || []);
    } catch (error) {
      notification.error({
        message: 'Unable to Load Airlines',
        description: 'Airline configuration could not be loaded.',
      });
    }
  };

  useEffect(() => {
    loadRows();
  }, []);

  const columns = [
    {
      key: 'name',
      title: 'Airline Name',
      required: true,
      placeholder: 'Airline name',
      width: 180,
    },
    {
      key: 'code',
      title: 'Code',
      placeholder: '6E',
      width: 90,
    },
    {
      key: 'excel_header',
      title: 'Excel Header',
      required: true,
      placeholder: 'Indigo \\n6E',
      type: 'textarea',
      width: 220,
      renderReadonly: (value) => <span style={{ whiteSpace: 'pre-line' }}>{value}</span>,
    },
    {
      key: 'is_active',
      title: 'Active',
      type: 'boolean',
      width: 110,
    },
  ];

  const handleSaveRows = async (changedRows) => {
    for (const row of changedRows) {
      const payload = {
        id: row.id,
        name: row.name,
        code: row.code,
        excel_header: normalizeExcelHeader(row.excel_header),
        is_active: row.is_active,
      };

      await axiosPost(API_UPDATE_AIRLINE, {
        ...payload,
      });
    }
    await loadRows();
  };

  const handleDeleteRow = async (row) => {
    if (!row.id) {
      return;
    }
    await axiosPost(API_DELETE_AIRLINE, { id: row.id });
    await loadRows();
  };

  return (
    <div style={{ position: 'relative', marginBottom: 50, marginTop: 25, width: "50%" }}>
      <Title level={4} style={{ textAlign: 'center', margin: 30 }}>
        Airlines
      </Title>

      <div style={{ width: '100%', maxWidth: '100%', }}>
        <EditableGridTable
          data={rows}
          columns={columns}
          rowKey="id"
          canEdit={canEdit}
          onSaveRows={handleSaveRows}
          onDeleteRow={handleDeleteRow}
          getNewRow={() => ({
            id: null,
            name: '',
            code: '',
            excel_header: '',
            is_active: true,
          })}
          cloneRow={(row) => ({
            id: null,
            name: row.name ? `${row.name} Copy` : '',
            code: row.code || '',
            excel_header: row.excel_header || '',
            is_active: row.is_active ?? true,
          })}
          searchKeys={['name', 'code', 'excel_header']}
          searchPlaceholder="Search airline"
          toolbarPosition="bottom"
        //   note="Use Active to control which airlines appear across the dashboard."
        />
      </div>
    </div>
  );
};


export default AirlineManagementSection;
